<template>
    <span>
        <v-tooltip
            :disabled="!icon.description || !icon.description(value, item)"
            top>
            <template v-slot:activator="{ on, attrs }">
                <a class="icon--button" @click.stop="dialog = !dialog">
                    <v-icon
                        v-if="icon.icon"
                        :color="icon.color && icon.color(value, item)"
                        v-bind="attrs"
                        v-on="on"
                    >{{ icon.icon(value, item) }}
                    </v-icon>
                    <img
                        v-else-if="icon.src"
                        :src="icon.src(value, item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                </a>
            </template>
            <span v-if="icon.description">{{ icon.description(value, item) }}</span>
        </v-tooltip>
        <v-dialog
            v-model="dialog"
            :width="dialogOption.width || '400'"
            :max-width="dialogOption.width || '400'"
            :persistent="false"
        >
            <v-card>
                <component
                        :is="icon.component(value, item)"
                        v-if="icon.component"
                        :item="item"
                        @close="dialog = false"
                ></component>
                <span v-else>No Dialog Content. Define component option!!</span>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
export default {
    name: "VueDataTableIconDialog",
    props: {
        icon: {
            type: Object,
            default: () => {},
        },
        item: {
            type: Object,
            default: () => {},
        },
        value: undefined,
        header: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
    computed: {
        dialogOption() {
            return this.icon.dialogOption || {};
        },
    },
}
</script>

<style scoped>
</style>